import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class EditKundorderradCommentCommand extends BasicCommand<EditKundorderradCommentCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<EditKundorderradCommentCommand>;
    kundorderradId: number;
    kommentar: string;

    constructor(kundorderradId: number, comment: string) {
        super("EditKundorderradCommentCommand", "kundorderrad", CommandType.Delete);
        this.kundorderradId = kundorderradId;
        this.kommentar = comment;
    }

}
